<template>
  <div>
    <!-- Form Modal -->
    <b-modal
      id="modal-season-form"
      ref="myModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      @ok="submit"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 v-if="box.id === null">
          Register Box
        </h5>
        <h5 v-if="box.id !== null">
          Edit Box
        </h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">

        <b-row>
          <b-col cols="12">
            <!-- <b-alert show variant="danger" v-if="errosOcurs" class="p-1">{{ errosOcurs.message }}</b-alert> -->

            <b-alert
              v-if="errosOcurs"
              show
              variant="danger"
            >
              <h4 class="alert-heading">
                {{ errosOcurs.message }}
              </h4>
              <div class="alert-body">
                <div
                  v-for="(errosOcurs, field) in errosOcurs.errors"
                  :key="field"
                >
                  <strong>{{ field }}:</strong>
                  <ul>
                    <li
                      v-for="message in errosOcurs"
                      :key="message"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreate"
          >
            <b-row>
              <b-col cols="4">
                <b-form-group
                  label-for="grn"
                  label="GRN Number"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="grn"
                    rules=""
                  >
                    <b-form-input
                      id="grn"
                      v-model="box.grn"
                      name="grn"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.grn"
                      class="text-danger"
                    >{{ serverErrors.grn[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label-for="number"
                  label="Box Number"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="number"
                    rules=""
                  >
                    <b-form-input
                      id="number"
                      v-model="box.number"
                      name="number"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.number"
                      class="text-danger"
                    >{{ serverErrors.number[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group
                  label-for="type"
                  label="Box Type"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="type"
                    rules=""
                  >
                    <b-form-select
                      id="type"
                      v-model="box.type"
                      name="type"
                      :options="options"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.type"
                      class="text-danger"
                    >{{ serverErrors.type[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-button
                  size="sm"
                  class="add-owner mb-1"
                  variant="outline-primary"
                  @click="addElement()"
                >
                  Add Range
                </b-button>
              </b-col>
              <table class="table">
                <thead>
                  <tr class="text-center">
                    <th>
                      <span v-if="box.type === null">Start Number</span>
                      <span v-else-if="parseInt(box.type) === 1">Start Barcode</span>
                      <span v-else>Start Continous #</span>
                    </th>
                    <th>
                      <span v-if="box.type === null">End Number</span>
                      <span v-else-if="parseInt(box.type) === 1">End Barcode</span>
                      <span v-else>End Continous #</span>
                    </th>
                    <!-- <th width="10%">Quantity</th> -->
                    <th width="3%" />
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="element, index in box.ranges"
                    :key="index"
                  >
                    <td scope="row">
                      <div>
                        <b-form-input
                          id="share"
                          v-model="element.start"
                          name="start"
                          size="sm"
                        />
                      </div>
                    </td>

                    <td>
                      <div>
                        <b-form-input
                          id="share"
                          v-model="element.end"
                          name="end"
                          size="sm"
                        />
                      </div>
                    </td>
                    <!-- <td>
                                            <div>

                                                <b-form-input id="share" name="quantity" v-model="element.quantity"
                                                    size="md" />

                                            </div>

                                        </td> -->
                    <td>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        @click="removeRow(index)"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          size="11"
                          class="text-danger stroke-current"
                        />
                      </b-button>
                    </td>
                    <!-- {{ element }} -->
                  </tr>
                  <tr>
                    <td scope="row" />
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </b-row>

            <!-- <pre>
                            {{ box }}
                        </pre> -->
          </b-form>
        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Form Range Modal -->
    <b-modal
      id="modal-range-form"
      ref="myRangeModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      @ok="submitUpdateRange"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Edit Range</h5>
        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="md"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button
          size="md"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">

        <b-row>
          <b-col cols="12">
            <!-- <b-alert show variant="danger" v-if="errosOcurs" class="p-1">{{ errosOcurs.message }}</b-alert> -->

            <b-alert
              v-if="errosOcurs"
              show
              variant="danger"
            >
              <h4 class="alert-heading">
                {{ errosOcurs.message }}
              </h4>
              <div class="alert-body">
                <div
                  v-for="(errosOcurs, field) in errosOcurs.errors"
                  :key="field"
                >
                  <strong>{{ field }}:</strong>
                  <ul>
                    <li
                      v-for="message in errosOcurs"
                      :key="message"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
            </b-alert>

          </b-col>
        </b-row>
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreate"
          >

            <b-row>

              <b-col cols="12">
                <b-form-group
                  labe-for="box_number"
                  label="Box number"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Box number"
                    rules=""
                  >
                    <b-form-input
                      id="number"
                      v-model="range.number"
                      name="number"
                      readonly
                      :state="errors.length > 0 ? false : null"
                      size="md"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.number"
                      class="text-danger"
                    >{{
                      serverErrors.number[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row>
              <table class="table">
                <thead>
                  <tr class="text-center">
                    <th>Start</th>
                    <th>End</th>
                    <!-- <th width="10%">Quantity</th> -->
                    <th width="3%" />
                  </tr>
                </thead>
                <tbody>

                  <tr>
                    <td scope="row">
                      <div>

                        <b-form-input
                          id="share"
                          v-model="range.start"
                          name="start"
                          size="md"
                        />

                      </div>
                    </td>

                    <td>
                      <div>

                        <b-form-input
                          id="share"
                          v-model="range.end"
                          name="end"
                          size="md"
                        />

                      </div>

                    </td>
                    <!-- <td>
                                            <div>

                                                <b-form-input id="quantity" type="number" name="quantity"
                                                    v-model="range.quantity" size="md" />

                                            </div>

                                        </td> -->
                    <!-- {{ element }} -->
                  </tr>
                  <tr>
                    <td scope="row" />
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-checkbox
                  v-model="range.hasMissing"
                  :checked="range.hasMissing"
                  class="custom-control-success"
                  name="check-button"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckCircleIcon" />
                  </span>
                  <span>Have Missing?</span>
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row v-if="range.hasMissing">
              <b-col cols="5">
                <b-form-group
                  labe-for="lastBarcode"
                  label="From Barcode"
                  style="cursor: pointer"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="lastBarCode"
                    rules=""
                  >
                    <b-form-input
                      id="lastBarcode"
                      v-model="range.lastBarcode"
                      name="lastBarcode"
                      size="md"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.lastBarcode"
                      class="text-danger"
                    >{{
                      serverErrors.lastBarcode[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group
                  labe-for="direction"
                  label="Direction"
                  style="cursor: pointer"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Gender"
                    rules=""
                  >
                    <b-form-select
                      id="direction"
                      v-model="range.direction"
                      size="md"
                      name="direction"
                      :state="errors.length > 0 ? false : null"
                    >
                      <b-form-select-option :value="null">-- Select
                        --</b-form-select-option>
                      <b-form-select-option value="1">
                        After
                      </b-form-select-option>
                      <b-form-select-option value="-1">
                        Before
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.direction"
                      class="text-danger"
                    >{{
                      serverErrors.direction[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group
                  labe-for="counts"
                  label="Counts"
                  style="cursor: pointer"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="count"
                    rules=""
                  >
                    <b-form-input
                      id="count"
                      v-model="range.count"
                      type="number"
                      name="count"
                      size="md"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.count"
                      class="text-danger"
                    >{{
                      serverErrors.count[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Box based on Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="mb-md-0 mb-2"
          >
            <location-filters
              size="sm"
              align="horizontal"
              @filter="changeFilters"
            />
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-media no-body>
              <b-media-body class="my-auto text-center">
                <b-row>
                  <b-col cols="4">
                    <h5>Boxes</h5>
                    {{ boxes.length }}
                  </b-col>
                  <b-col cols="4">
                    <h5>Tickets</h5>
                    {{ baleTickets.length }}
                  </b-col>
                  <b-col cols="4">
                    <h5>Tags</h5>
                    {{ baleTags.length }}
                  </b-col>
                </b-row>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
              <b-button
                variant="primary"
                size="sm"
                @click="invokeCreateForm()"
              >
                <span class="text-nowrap">Add Box</span>
              </b-button>
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(address)="data">
          {{ data.item.address ? data.item.address.location.name.toUpperCase() : '' }}
        </template>

        <template #cell(type)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.type)}`"
            class="text-capitalize"
          >
            <span v-if="data.item.type == 1">Bale Ticket</span>
            <span v-else-if="data.item.type == 2">Luggage</span>
            <span v-else>Sweeping</span>
          </b-badge>
        </template>
        <template #cell(received)="data">
          <b-badge
            pill
            :variant="`light-${resolveReceivedVariant(data.item.received)}`"
            class="text-capitalize"
          >
            <span v-if="data.item.received == true">Yes</span>
            <span v-else-if="data.item.received == false">No</span>
          </b-badge>
        </template>

        <template #cell(ranges)="data">
          <div class="ranges">
            <table
              width="100%"
              class="text-no-wrap"
            >
              <thead>
                <tr>
                  <th class="text-uppercase">
                    Start
                  </th>
                  <th class="text-uppercase">
                    End
                  </th>
                  <!-- <th class="text-uppercase">
                                        Qty
                                    </th> -->

                  <th class="text-uppercase">
                    Actual Qty
                  </th>
                  <th class="text-uppercase">
                    Missing
                  </th>
                  <th class="text-uppercase" />

                </tr>
              </thead>

              <tbody>
                <tr v-for="range in data.item.ranges">
                  <td>
                    {{ range.start }}
                  </td>
                  <td>
                    {{ range.end }}
                  </td>
                  <!-- <td>
                                        {{ range.quantity }}
                                    </td> -->
                  <td>
                    {{ range.actual - range.missing }}
                  </td>
                  <td>
                    {{ range.missing }}
                  </td>
                  <td>
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="invokeRangeUpdateForm(range, data.item)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>

          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner, BFormCheckbox, BBadge, BAlert,
    BMedia, BMediaAside, BMediaBody, BAvatar,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import {
    ref, onUnmounted, onMounted, reactive,
} from '@vue/composition-api'

import boxesStoreModule from '@/views/cromis/inventory/box/boxesStoreModule'
import useBoxesList from '@/views/cromis/inventory/box/useBoxesList'
import LocationFilters from '@core/components/cromis/filters/LocationFilters'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
        BFormCheckbox,
        BBadge,
        BAlert,
        BMedia,
        BMediaAside,
        BMediaBody,
        BAvatar,

        LocationFilters,
    },
    directives: {},
    props: {},
    watch: {
        userInput(newInput, oldInput) {
            // Update default value when user input changes
            if (!isNaN(newInput)) {
                this.defaultValue -= (newInput - oldInput)
            } else {
                // Handle case where userInput is NaN (e.g., after deleting the number)
                this.defaultValue = this.defaultValue
            }
        },
    },

    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const myRangeModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)
        const errosOcurs = ref(null)
        const selections = ref([])
        const formSelections = ref([])
        const levels = ref(null)
        const companies = ref([])
        const societies = ref([])
        const children = ref([])
        const boxes = ref([])
        const baleTickets = ref([])
        const baleTags = ref([])
        const box = ref({
            id: null,
            number: null,
            type: null,
            grn: null,
            ranges: [
                {
                    start: null,
                    end: null,
                    quantity: null,
                },
            ],
        })

        const range = ref({
            id: null,
            box_id: null,
            number: null,
            start: null,
            end: null,
            quantity: null,
            hasMissing: false,
            lastBarcode: null,
            direction: null,
            count: null,
        })

        const addElement = () => {
            box.value.ranges.push({ start: '', end: '', quantity: '' })
            if (box.value.ranges.length > 0) {
                console.log(box.value.ranges)
            }
        }

        const removeRow = index => {
            console.log(index)
            if (box.value.ranges.length > 1) {
                box.value.ranges.splice(index, 1)
                box.value.ranges = box.value.ranges
            }
        }

        const CROMIS_STORE_MODULE_NAME = 'cromis-box'
        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, boxesStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-box/list')
                .then(response => {
                    boxes.value = response.data.boxes

                    boxes.value.forEach(ele => {
                        if (ele.type == 1) {
                            baleTickets.value.push(ele)
                        } else {
                            baleTags.value.push(ele)
                        }
                    })
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const changeFilters = async location => {
            locationFilter.value = location != null ? location.id : null
        }

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filers
            resolveStatusVariant,
            resolveReceivedVariant,
            locationFilter,
        } = useBoxesList()

        // Form Methods
        const invokeUpdateForm = item => {
            serverErrors.value = null
            errosOcurs.value = null

            box.value = {
                id: item.id,
                type: item.type,
                number: item.number,
                grn: item?.grn,
                ranges: item.ranges,
                quantity: 1,
            }

            myModal.value.show()
        }

        const invokeCreateForm = () => {
            formSelections.value.map(form => {
                form.model = null
            })

            box.value = {
                id: null,
                number: null,
                grn: null,
                type: null,
                ranges: [
                    {
                        start: null,
                        end: null,
                        quantity: 1,
                    },
                ],
            }

            myModal.value.show()
        }

        const invokeRangeUpdateForm = (ranges, par) => {
            formSelections.value.map(form => {
                form.model = null
            })

            range.value = {
                id: ranges.id,
                box_id: par.id,
                number: par.number,
                grn: par?.grn,
                start: ranges.start,
                end: ranges.end,
                quantity: ranges.quantity,
                hasMissing: null,
                lastBarcode: null,
                direction: null,
                count: null,
            }

            myRangeModal.value.show()
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            // Handle form submit
            if (box.value.id === null || box.value.id === 0) handleCreate()
            else handleUpdate(box.value)
        }

        const submitUpdateRange = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            handleUpdateRange(range.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-box/create', box.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: 'Box has been added successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    errosOcurs.value = error.response.data
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdateRange = async item => {
            console.log(item)
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-box/range', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    myRangeModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: 'Changes to box range has been saved successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response.data
                    console.log(error.response)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors

                        console.log(serverErrors)
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            console.log(item)
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-box/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to box center ${response.data.code} ${response.data.name} has been saved successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response.data
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const confirmDelete = async id => {
            const result = context.root.$swal({
                icon: 'info',
                title: 'System Info',
                text: 'Are you sure you want to delete the Box?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel',
                customClass: {
                    confirmButton: 'btn btn-info',
                    cancelButton: 'btn btn-danger ml-2', // Optional: Customize the cancel button class
                },
                buttonsStyling: true,
            }).then(result => {
                if (result.value) {
                    remove(id)
                } else {
                    context.root.$swal({
                        icon: 'info',
                        title: 'Cancelled',
                        text: 'Your Box is safe you cancell deletion of it',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                }
            })
        }
        const deleteItem = async () => {
            context.root.$swal({
                icon: 'info',
                title: 'Cancelled',
                text: 'Your Box is safe you cancell deletion of it',
                showConfirmButton: true,
                customClass: {
                    confirmButton: 'btn btn-info',
                },
                buttonsStyling: true,
            })
        }

        const remove = async id => {
            await store.dispatch('cromis-box/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        return {
            // Data
            selections,
            formSelections,
            levels,
            children,
            box,
            range,
            selectedOwner: null,
            addedElement: null,
            clientName: JSON.parse(localStorage.getItem('userData')).client,
            options: [
                { value: null, text: '-- Select Box Type --' },
                { value: 1, text: 'Bale Ticket' },
                { value: 2, text: 'Bale Tags' },
                { value: 3, text: 'Sweeping Tickets' },
            ],
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            resolveStatusVariant,
            resolveReceivedVariant,

            // Methods

            required,
            saving,
            serverErrors,
            dataForm,
            myModal,
            myRangeModal,
            changeFilters,
            invokeCreateForm,
            invokeUpdateForm,
            invokeRangeUpdateForm,
            submit,
            submitUpdateRange,
            isFormValid,
            handleCreate,
            handleUpdate,
            handleUpdateRange,
            remove,
            addElement,
            removeRow,
            companies,
            societies,
            confirmDelete,
            deleteItem,
            errosOcurs,
            boxes,
            baleTickets,
            baleTags,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
